import { render, staticRenderFns } from "./ReleaseFugaUpload.vue?vue&type=template&id=f0509c82&"
import script from "./ReleaseFugaUpload.vue?vue&type=script&lang=js&"
export * from "./ReleaseFugaUpload.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseFugaUpload.vue?vue&type=style&index=0&id=f0509c82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports